module.exports = __webpack_public_path__ + "img/paw2.35ba131e.png";